import { render, staticRenderFns } from "./Warehousing.vue?vue&type=template&id=6678dd97&scoped=true&"
import script from "./Warehousing.vue?vue&type=script&lang=js&"
export * from "./Warehousing.vue?vue&type=script&lang=js&"
import style0 from "./Warehousing.vue?vue&type=style&index=0&id=6678dd97&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6678dd97",
  null
  
)

export default component.exports